import { type ReactNode } from 'react'

import './styles.scss'

interface GenericCardWithTitleProps {
  title: string
  subtitle: string
  icon?: JSX.Element
  children: ReactNode
}

function GenericCardWithTitle({
  title,
  subtitle,
  icon = <></>,
  children,
}: GenericCardWithTitleProps) {
  return (
    <section className="container-genericCard">
      <div className="container-genericCard__header">
        <h1>
          {icon}
          {title}
        </h1>
        <h2>{subtitle}</h2>
      </div>
      <div className="container-genericCard__body">{children}</div>
    </section>
  )
}

export default GenericCardWithTitle
